
import { Vue, Component, Prop } from 'vue-property-decorator';
import Domain from '@/components/Domain.vue';
import { DomainData } from '../types';

@Component({
	components: {
		Domain
	}
})
export default class DomainList extends Vue {
	private get domains(): DomainData[] {
		return Object.values(this.$store.state.domains);
	}
}
